<template>
	<q-select ref="customerSelect"
			  :value="customerSearchWord"
			  @input="selectCustomer"
			  use-input
			  hide-selected
			  fill-input
			  input-debounce="500"
			  :label="$t('customer')"
			  :options="customers"
			  option-label="Account_Name"
			  @filter="filterCustomers"
			  :loading="loading"
			  :error="error"
			  :error-message="$t('error.customer')"
	>
		<template v-slot:no-option="scope">
			<div class="q-pa-md">{{ $t('noResults') }}</div>
		</template>
	</q-select>
</template>

<script>
	import {SEARCH_ZOHO_CUSTOMERS} from "@/store/actions.type";

	export default {
		name: "CustomerSelect",
		props: ['customerName', 'error'],
		data() {
			return {
				customerSearchWord: '',
				customers: [],
				loading: false,
				initialLoadDisplay: false
			}
		},
		mounted() {
			this.customerSearchWord = this.customerName || '';
		},
		watch: {
			customerName() {
				this.customerSearchWord = this.customerName || '';
			}
		},
		methods: {
			async filterCustomers(val, update, abort) {
				await update(async () => {
					const needle = val.toLowerCase().trim();

					if (needle.length > 0) {
						this.loading = true;
						this.customers = await this.$store.dispatch(SEARCH_ZOHO_CUSTOMERS, needle) || [];
						this.loading = false;

						if (!this.initialLoadDisplay) {
							this.$refs.customerSelect.showPopup();
							this.initialLoadDisplay = true;
						}
					}
				});
			},
			selectCustomer(customer) {
				this.$emit('input', customer);
				this.customerSearchWord = customer.Account_Name;
			}
		}
	}
</script>